<template>
  <base-echart
    :options="option"
    @legendselectchanged="handleLegendSelectChange"
  />
</template>

<script>
import { getMasterDataText } from '../../helpers'

const colors = [
  '#ff7675', // red
  '#fdcb6e', // blue
  '#0984e3', // green
]

export default {
  props: [
    'items',
    'type',
    'selectedKey',
  ],

  computed: {
    paymentTypes () {
      return this.items.reduce((acc, cur) => {
        cur.paymentMethods.map((item) => item.paymentType).forEach((paymentMethod) => {
          if (!acc.includes(paymentMethod)) {
            acc.push(paymentMethod)
          }
        })
        return acc
      }, [])
    },
    barChartLineChartOption () {
      const series = this.paymentTypes.map((paymentType, index) => {
        return {
          data: this.items.map((item) => {
            const result = item.paymentMethods.find((itemPaymentMethod) => (
              itemPaymentMethod.paymentType === paymentType
            ))
            return result ? result[this.selectedKey] : null
          }),
          type: this.type,
          stack: 'a',
          name: getMasterDataText(paymentType, this.$t),
          label: {
            show: true,
            formatter: (params) => [null, '-', 0].includes(params.value) ? '' : params.value,
          },
          color: colors[index],
        }
      })
      return {
        legend: {
          selectedMode: true,
        },
        xAxis: {
          type: 'category',
          data: this.items.map((item) => item.date),
        },
        yAxis: {
          type: 'value',
        },
        series: series,
      }
    },
    pieChartOption () {
      return {
        color: colors,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            label: {
              show: true,
              formatter (param) {
                return param.name + ' (' + param.percent + '%)'
              },
            },
            data: this.paymentTypes.map((paymentType) => {
              return {
                value: this.items.reduce((acc, cur) => {
                  const total = cur.paymentMethods.reduce((_acc, _cur) => {
                    if (_cur.paymentType === paymentType) {
                      _acc += _cur[this.selectedKey]
                    }
                    return _acc
                  }, 0)
                  return acc + total
                }, 0),
                name: getMasterDataText(paymentType, this.$t),
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    option () {
      if (this.type === 'bar' || this.type === 'line') {
        return this.barChartLineChartOption
      }
      return this.pieChartOption
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportPosPaymentMethodChart.vue